<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Beneath the Soil</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<h3 class="books-by-head"><em>Recent Titles by Fay Sampson from Severn House</em></h3>
<p class="books-by-text-1-space-after"><em>The Suzie Fewings Genealogical Mysteries</em></p>
<p class="books-by-text-1">IN THE BLOOD</p>
<p class="books-by-text-1">A MALIGNANT HOUSE</p>
<p class="books-by-text-1">THOSE IN PERIL</p>
<p class="books-by-text-1">FATHER UNKNOWN</p>
<p class="books-by-text-1">THE OVERLOOKER</p>
<p class="books-by-text-1">BENEATH THE SOIL</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsoby.vue?6eee0697